import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SelectContentDirective } from './directives/select-content.directive';
import { SelectItemDirective } from './directives/select-item.directive';
import { SelectPromotionDirective } from './directives/select-promotion.directive';
import { ViewItemListDirective } from './directives/view-item-list.directive';
import { ViewItemDirective } from './directives/view-item.directive';
import { ViewPromotionDirective } from './directives/view-promotion.directive';
import { MapGA4ItemsPipe } from './pipes/map-ga4-items.pipe';

@NgModule({
    declarations: [
        ViewItemListDirective,
        SelectItemDirective,
        ViewItemDirective,
        ViewPromotionDirective,
        SelectPromotionDirective,
        SelectContentDirective,
        MapGA4ItemsPipe,
    ],
    imports: [CommonModule],
    providers: [

    ],
    exports: [
        ViewItemListDirective,
        SelectItemDirective,
        ViewItemDirective,
        ViewPromotionDirective,
        SelectPromotionDirective,
        SelectContentDirective,
        MapGA4ItemsPipe,
    ]
})
export class TagManagerModule {}


